import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { SiteLayout } from "../components/site/SiteLayout";

const Box = ({ icon, title, text, children, testid }) => (
  <div className="max-w-xl mx-auto my-20 scroll-card p-10 text-center font-serif-tc" data-testid={testid}>
    {icon}
    <h1 className="text-3xl font-black text-[var(--tea)] mt-4">{title}</h1>
    <p className="text-stone-600 mt-3">{text}</p>
    <div className="mt-6 flex justify-center gap-3">{children}</div>
  </div>
);

export const PaymentSuccess = () => {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const nav = useNavigate();
  const [state, setState] = useState("checking");
  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) return setState("error");
    let n = 0, stop = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { await refresh(); return !stop && setState("paid"); }
        if (["expired", "failed"].includes(data.payment_status)) return !stop && setState("error");
      } catch { return !stop && setState("error"); }
      if (++n >= 15) return !stop && setState("timeout");
      setTimeout(poll, 2000);
    };
    poll();
    return () => { stop = true; };
  }, [params, refresh]);
  return (
    <SiteLayout>
      {state === "checking" && <Box testid="payment-checking" icon={<Loader2 size={48} className="mx-auto animate-spin text-[var(--jade)]" />} title="確認付款中…" text="請稍候，正在向 Stripe 確認您的訂閱。" />}
      {state === "paid" && (
        <Box testid="payment-success" icon={<CheckCircle2 size={56} className="mx-auto text-[var(--jade)]" />} title="歡迎加入 Premium！" text="三座故事館的所有課程都已經打開了，快帶孩子去冒險吧！">
          <button data-testid="payment-success-start-btn" onClick={() => nav("/profiles")} className="kid-btn px-8 bg-[var(--jade)] text-white">開始學習</button>
          <button data-testid="payment-success-parent-btn" onClick={() => nav("/parent")} className="kid-btn px-8 bg-white border-2 border-[var(--line)] text-[var(--tea)]">家長報告</button>
        </Box>
      )}
      {(state === "error" || state === "timeout") && (
        <Box testid="payment-error" icon={<XCircle size={56} className="mx-auto text-[var(--vermilion)]" />} title={state === "timeout" ? "還在處理中" : "付款沒有完成"} text={state === "timeout" ? "付款確認需要多一點時間，請稍後到家長報告查看方案狀態。" : "沒有扣款。您可以回到方案頁再試一次。"}>
          <Link to="/pricing" data-testid="payment-error-back-btn" className="kid-btn px-8 bg-[var(--vermilion)] text-white">回到方案與價格</Link>
        </Box>
      )}
    </SiteLayout>
  );
};

export const PaymentCancel = () => (
  <SiteLayout>
    <Box testid="payment-cancel" icon={<XCircle size={56} className="mx-auto text-stone-400" />} title="已取消付款" text="沒有扣款。想清楚了隨時都可以回來訂閱。">
      <Link to="/pricing" data-testid="payment-cancel-back-btn" className="kid-btn px-8 bg-[var(--vermilion)] text-white">回到方案與價格</Link>
    </Box>
  </SiteLayout>
);
